import { GridColDef } from '@mui/x-data-grid';
import { Button, Chip } from '@mui/material';
import { AdSpacePaymentDetailsInterface } from '../../../interfaces/interfaces';

export const getPaymentDetailsColumns = (
  setPaymentToDelete: (payment: AdSpacePaymentDetailsInterface) => void,
  setDeleteDialogOpen: (open: boolean) => void,
  setPaymentToUpdate: (payment: AdSpacePaymentDetailsInterface) => void,
  setUpdateDialogOpen: (open: boolean) => void
): GridColDef[] => [
  { field: 'id', headerName: 'ID', width: 70 },
  { field: 'userId', headerName: 'User ID', width: 100 },
  { 
    field: 'stripePaymentIntentId', 
    headerName: 'Payment Intent', 
    width: 200,
    renderCell: (params) => (
      <span style={{ fontSize: '0.75rem', fontFamily: 'monospace' }}>
        {params.value || 'N/A'}
      </span>
    )
  },
  { 
    field: 'status', 
    headerName: 'Status', 
    width: 120,
    renderCell: (params) => {
      const status = params.value as string;
      const color = status === 'paid' ? 'success' : status === 'failed' ? 'error' : 'warning';
      return <Chip label={status?.toUpperCase()} color={color} size="small" />;
    }
  },
  { 
    field: 'stripeAmountPaid', 
    headerName: 'Amount (USD)', 
    width: 130,
    renderCell: (params) => {
      const amount = params.value as number;
      return amount ? `$${(amount / 100).toFixed(2)}` : '$0.00';
    }
  },
  { 
    field: 'completedAt', 
    headerName: 'Completed', 
    width: 160,
    renderCell: (params) => {
      if (!params.value) return 'N/A';
      return new Date(params.value).toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
      });
    }
  },
  { 
    field: 'createdAt', 
    headerName: 'Created', 
    width: 160,
    renderCell: (params) => {
      return new Date(params.value).toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });
    }
  },
  {
    field: 'update',
    headerName: 'Update',
    width: 100,
    renderCell: (params) => (
      <Button
        color="primary"
        variant="outlined"
        size="small"
        onClick={() => {
          setPaymentToUpdate(params.row);
          setUpdateDialogOpen(true);
        }}
      >
        Edit
      </Button>
    ),
    sortable: false,
    filterable: false,
  },
];
